import $ from 'jquery';

(function () {
    var youtube = document.querySelectorAll(".youtubeblock > .embed-responsive");
    for (var i = 0; i < youtube.length; i++) {
        youtube[i].addEventListener("click", function () {

            var iframe = document.createElement("iframe");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("class", "embed-responsive-item");
            iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1&mute=1");
            this.innerHTML = "";
            this.appendChild(iframe);

        });
    }
})();

const setPreviewImage = (elem, youTubeId) => {
  const mobileView = $(window).width() < 768;
  const previewImageFileName = mobileView ? 'mqdefault.jpg' : 'maxresdefault.jpg';
  const previewImageUrl = 'https://img.youtube.com/vi/' + youTubeId + '/' + previewImageFileName;
  const $img = $('#' + elem).children('.embed-responsive-item');
  $img.attr('data-src', previewImageUrl); // Set data-src for lazyload
  $img.attr('src', previewImageUrl); // Set src for lazyload
}

$(document).ready(function (){
  $('.block.youtubeblock').each(function () {
    const blockId = $(this).children('.embed-responsive').attr('id');
    const youTubeId = $(this).children('.embed-responsive').attr('data-embed');
    setPreviewImage(blockId, youTubeId)

  })

});